<div class="container">
    <mat-toolbar>
        <span>Numeraciones de documentos</span>
        <span class="toolbar-spacer"></span>
        <button mat-flat-button type="button" (click)="onAddTramiteAbreviacion()">Nuevo</button>
    </mat-toolbar>
    <table mat-table [dataSource]="dataSource">        
        <ng-container matColumnDef="depaNombre">
            <th mat-header-cell *matHeaderCellDef> Departamento </th>
            <td mat-cell *matCellDef="let element"> {{element.depaNombre}} </td>
        </ng-container>

        <ng-container matColumnDef="abreviatura">
            <th mat-header-cell *matHeaderCellDef> Numeración </th>
            <td mat-cell *matCellDef="let element"> {{element.abreviatura}} </td>
        </ng-container>

        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef class="acciones" style="width: 120px;"></th>
            <td mat-cell *matCellDef="let element">
                <button mat-icon-button (click)="onUpdateTramiteAbreviacion(element)" matTooltip="Editar" type="button">
                    <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button (click)="onDeleteTramiteAbreviacion(element.id)" matTooltip="Eliminar"
                    type="button">
                    <mat-icon>delete</mat-icon>
                </button>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
</div>